/* Book a wheelchair journey */
'use strict';

export default class BookWheelchairBasket {
    constructor(element) {
        this.root = element;
        this.wheelchairPricePerWeek = parseFloat(this.root.getAttribute('data-price-wc-input'));
        this.durationSelector = this.root.querySelector('select[data-duration-select]');
        this.selectedDuration = this.durationSelector.options[this.durationSelector.selectedIndex].value; //Default value
        this.wheelchairCost = this.wheelchairPricePerWeek * this.selectedDuration;
        this.vatAmount = (this.root.getAttribute('data-vat') / 100) + 1;
        this.accessoryRows = this.root.querySelectorAll('.wheelchair-basket__accessory');
        this.startDateInput = new Date(this.root.getAttribute('data-start-date'));
        this.durationOutputs = this.root.querySelectorAll('[data-duration-output]');
        this.weekTextOutputs = this.root.querySelectorAll('[data-weeks-output]');
        this.endDateOutputs = this.root.querySelectorAll('[data-end-date-output]');
        this.wheelchairPriceOutputs = this.root.querySelectorAll('[data-wc-price-output]');
        this.totalPriceOutput = this.root.querySelector('[data-total-output]');
        this.subtotalPriceOutput = this.root.querySelector('[data-subtotal-output]');
        this.vatPriceOutput = this.root.querySelector('[data-vat-output]');
        this.removeBtns = this.root.querySelectorAll('.wheelchair-basket__remove-btn');

        this.bindEvents();

        this.handleDurationChange(this.durationSelector);
    }

    changeDurationText(duration, weeksText) {
        //Re-set outputs - these can be added by the accessories selection
        this.durationOutputs = this.root.querySelectorAll('[data-duration-output]');
        //Change all duration outputs
        for (let i = 0; i < this.durationOutputs.length; i++) {
            this.durationOutputs[i].textContent = duration;
        }

        //Change all week text outputs
        for (let i = 0; i < this.weekTextOutputs.length; i++) {
            this.weekTextOutputs[i].textContent = weeksText;
        }
    }

    changeEndDate(duration) {
        //Calc end date
        let endDate = new Date(this.startDateInput.valueOf());
        let days = duration * 7;

        for (let i = 0; i < this.endDateOutputs.length; i++) {
            let formattedDate;

            endDate.setDate(endDate.getDate() + days);
            formattedDate = ('0' + endDate.getDate()).slice(-2) + '/' + ('0' + (endDate.getMonth()+1)).slice(-2) + '/' + endDate.getFullYear();

            this.endDateOutputs[i].textContent = formattedDate;
        }
    }

    changeCost(duration) {
        let accessorySubtotal = 0;
        this.accessoryRows = this.root.querySelectorAll('.wheelchair-basket__accessory');

        //Calc new individual wc item cost
        this.wheelchairCost = this.wheelchairPricePerWeek * duration;

        //Display new single wc item cost
        for (let i = 0; i < this.wheelchairPriceOutputs.length; i++) {
            this.wheelchairPriceOutputs[i].textContent = this.wheelchairCost.toFixed(2);
        }
        
        //Calc total accessory cost (user can pick more than one)
        for (let i = 0; i < this.accessoryRows.length; i++) {
            let accessoryPricePerWeek = this.accessoryRows[i].querySelector('[data-acc-price-input]').textContent;
            let accessoryCost = accessoryPricePerWeek * duration;
            this.accessoryRows[i].querySelector('[data-acc-price-output]').textContent = accessoryCost.toFixed(2); 
            accessorySubtotal += parseFloat(this.accessoryRows[i].querySelector('[data-acc-price-output]').textContent);  
        } 

        //Calc total price for wheelchair and accessories
        let totalPrice = accessorySubtotal + this.wheelchairCost;

        //Calc subtotal and VAT breakdowns
        let subtotalPrice = totalPrice / this.vatAmount;
        let vatPrice = subtotalPrice * 0.2; 

        //Change subtotal, VAT and total cost values on page
        if (this.totalPriceOutput) {
            this.totalPriceOutput.textContent = totalPrice.toFixed(2);
        }
        if (this.subtotalPriceOutput) {
            this.subtotalPriceOutput.textContent = subtotalPrice.toFixed(2);
        }
        if (this.vatPriceOutput) {
            this.vatPriceOutput.textContent = vatPrice.toFixed(2);
        }
    }

    handleDurationChange(select) {
        this.selectedDuration = parseFloat(select.options[select.selectedIndex].getAttribute('data-duration-option'));
        let weeksWord = 'week(s)';

        this.changeDurationText(this.selectedDuration, weeksWord);

        this.changeEndDate(this.selectedDuration);

        if (this.wheelchairPricePerWeek != 0) {
            this.changeCost(this.selectedDuration);
        }
    }

    removeItem(removeBtn) {
        event.preventDefault();
        let itemRow = removeBtn.closest('tr');
        let basketTable = this.root.querySelector('tbody');
        basketTable.removeChild(itemRow);
        this.changeCost(this.selectedDuration);
    }

    bindEvents() {
        //User selects new duration for equipment booking
        if (this.durationSelector) {
            this.durationSelector.addEventListener('change', this.handleDurationChange.bind(this, this.durationSelector));
        }

        for (let i = 0; i < this.removeBtns.length; i++) {
            this.removeBtns[i].addEventListener('click', this.removeItem.bind(this, this.removeBtns[i]));
        }
    }
}
